import PostbackActions from '../../../../actions/PostbackActions';
import GoalActions from '../../../../actions/GoalActions';
import store from '../../../../stores/redux';

export const actions = {
    getListPostbacks(params = {}) {
        PostbackActions.getListPostbacks({
            page: params.page
        }, () => {
            const ids = _getListIdsGoalActions();
            if (!ids.length) {
                return;
            }
            GoalActions.getListGoalActions({
                ids: ids.join(','),
                fields: 'goal_action.goal,goal.offer',
                count: ids.length
            });
        });
    },

    getListGoalActionsByIds(ids) {
        const list = [];
        const goalActions = store.getState().goalActions.list || [];

        if (Array.isArray(ids) && ids.length) {
            ids.forEach((id) => {
                const normalizedId = String(id);
                const goalAction = goalActions.find((item) => String(item.id) === normalizedId);
                list.push(goalAction || normalizedId);
            });
        }

        return list;
    },

    onDeletePostback(state) {
        PostbackActions.deletePostback({
            id: state.deletePostbackId
        }, () => {
            actions.getListPostbacks({page: state.page});
        });
    }
};

const _getListIdsGoalActions = () => {
    let ids = [];
    const postbacks = store.getState().postbacks.list.data;

    postbacks.map((item) => {
        const goalActionsIds = item.config.goal_action_ids;

        if (goalActionsIds && goalActionsIds.length) {
            ids = ids.concat(goalActionsIds);
        }
    });

    return Array.from(new Set(
        ids
            .map((id) => String(id).trim())
            .filter((id) => id && !isNaN(id))
    ));
};
